
import TableList from "@components/templates/tablelist";
import {
    HttpTransferInboundList,
    HttpTransferInboundConfirm,
    HttpTransferInboundCancel,
    HttpTransferAdminWarehouseList
} from "@/service/transferplan";
import { mapState, mapGetters } from "vuex";
import compAdd from "./add";
import compUpdate from "./update";
import ajaxmixin from "../ajaxmixin";
import mixin from "../mixin";
export default {
    mixins: [TableList, mixin, ajaxmixin],
    components: {
        compAdd,
        compUpdate
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            queryWarehouseList: [],
        };
    },
    created() {
        this.getMixinWarehouse(true);
        HttpTransferAdminWarehouseList().then(res => {
            console.log('res', res);
            this.queryWarehouseList = res.data.map(item => {
                return {
                    value: item.code,
                    label: item.title ? `${item.code}(${item.title})` : item.code,
                    attach: {
                        ...item
                    }
                };
            });
        }, err => {
            this.$VMessage.error(err.message);
        });
    },
    methods: {
        ajaxRequest: HttpTransferInboundList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            console.log(type);
            switch (type) {
                case "add":
                    // this.$router.push({
                    //     name: 'transferPlanUpdate',
                    //     params: { type: "add" },
                    //     // query: { id: params },
                    // });
                    this.operate = {
                        show: true,
                        title: "添加",
                        width: 900,
                        component: "compAdd",
                        showFooter: false
                    }
                    break;
                case "edit":
                    {
                        let url = this.$router.resolve({
                            name: 'transferPlanInboundUpdate',
                            params: { type: "edit" },
                            query: { id: params },
                        });
                        window.open(url.href, '_blank');
                    }
                    break;
                case "query":
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "queryBlank":
                    {
                        let url = this.$router.resolve({
                            name: "transferPlanInboundUpdate",
                            params: { type: "query" },
                            query: { id: params },
                        });
                        window.open(url.href, '_blank');
                    }
                    break;
                case "confirm":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "确认",
                        width: 460,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 22,
                                showDesc: false,
                                labelWidth: 100,
                                label: this.$t('global.common.notes', { defaultValue: "备注" }),
                                required: false
                            }
                        ],
                        ajaxRequest: HttpTransferInboundConfirm,
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operate_cancel', { defaultValue: "取消" }),
                        width: 460,
                        showDesc: false,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 22,
                                labelWidth: 100,
                                label: "取消原因",
                            }
                        ],
                        ajaxRequest: HttpTransferInboundCancel,
                    };
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/TransitInbound/batchExport",
                        {
                            ...this.formData
                        }
                        , {
                            executor: 'request',
                            download: true,
                        }).catch(err => {
                            this.$VMessage.error(err.message);
                        })
                    break
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: this.handleAuth('fbb.transfer.inboundview'),
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                    show: status == 0 && this.handleAuth('fbb.transfer.inboundedit'),
                    params: id,
                    operate: 'edit'
                },
                {
                    label: "确认",
                    show: status == 0 && this.handleAuth('fbb.transfer.inboundedit'),
                    params: id,
                    operate: "confirm"
                },
                {
                    label: this.$t('global.common.operate_cancel', { defaultValue: '取消' }),
                    show: status == 0 && this.handleAuth('fbb.transfer.inboundedit'),
                    params: id,
                    operate: 'cancel'
                },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList', 'getCusproductList', 'getSystemPortList', 'getCompanyList', 'getFilterDisabledWarehouse']),
        choseOrderStatusList() {
            return this.orderStatusList.filter(item => {
                return item.value != 10
            })
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                    show: this.handleAuth('fbb.transfer.inboundedit')
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'export',
                    show: this.handleAuth('fbb.transfer.inboundexport'),
                    theme: 'primary'
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 220px;'
            return [
                {
                    label: '转运入库单号',
                    tag: 'vInput',
                    key: 'EQ_transitInboundOrderNo',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: '来源单号',
                    tag: 'vInput',
                    key: 'EQ_sourceNo',
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: "转运计划单号",
                    tag: "vInput",
                    key: "EQ_transitPlanOrderNo",
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: "状态",
                    tag: "vSelect",
                    options: this.getBoundStatus,
                    props: {
                        multiple: true
                    },
                    key: "IN_status",
                    show: true,
                    style: 'width: 130px;'
                },
                {
                    label: '仓库',
                    key: 'IN_orgWarehouseCode',
                    tag: 'Select',
                    options: this.queryWarehouseList,
                    props: {
                        multiple: true,
                        filterable: true
                    },
                    style: widthStyle
                },
                {
                    label: this.$t('global.common.line', { defaultValue: '项目' }),
                    key: 'IN_lineId',
                    tag: 'Select',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    // default:this.initData,
                    props: {
                        // options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: "客户",
                    tag: "Select",
                    options: this.getSelfmanageorgList,
                    key: "IN_organizationId",
                    props: {
                        multiple: true,
                        filterable: true
                    },
                    style: widthStyle
                }
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                    // fixed: 'left'
                },
                {
                    title: "客户",
                    key: "organizationId",
                    render: (h, { row }) => {
                        let orgItem = this.getSelfmanageorgList.filter(item => {
                            return item.value == row.organizationId
                        })[0];
                        return <div>{orgItem ? orgItem.label : "--"}</div>
                    }
                },
                {
                    title: '转运入库单',
                    sortable: true,
                    // fixed: 'left',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.transitInboundOrderNo || '--'}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                    }
                },
                {
                    title: "来源单号",
                    key: "sourceNo",
                    render: (h, { row }) => {
                        return <div>{row.sourceNo || "--"}</div>
                    }
                },
                {
                    title: "转运计划单号",
                    key: "transitPlanOrderNo"
                },
                {
                    title: '状态',
                    render: (h, { row }) => {
                        let statusItem = this.getBoundStatus.filter(item => {
                            return item.value == row.status;
                        })[0];
                        return <div>{statusItem ? statusItem.label : "--"}</div>
                    }
                },
                {
                    title: "仓库",
                    render: (h, { row }) => {
                        let warehouseItem = this.mixinWarehouseList.filter(item => {
                            return item.value == row.orgWarehouseId
                        })[0];
                        return <div>{warehouseItem ? warehouseItem.label : "--"}</div>
                    }
                },
                {
                    title: '项目',
                    render: (h, { row }) => {
                        let lineItem = this.getCusproductList.filter(item => {
                            return item.value == row.lineId;
                        })[0];
                        return <div>
                            <div>{lineItem ? lineItem.label : '--'}</div>
                        </div>
                    }
                },
                {
                    // title: '负责人/更新时间',
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    width: 180
                },
            ];
        },

    },

};
